var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPictureAsPdf = function SvgPictureAsPdf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 96 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M331 625h37v-83h48q15.725 0 26.362-10.638Q453 520.725 453 505v-48q0-15.725-10.638-26.362Q431.725 420 416 420h-85zm37-120v-48h48v48zm129 120h84q15 0 26-10.638T618 588V457q0-15.725-11-26.362Q596 420 581 420h-84zm37-37V457h47v131zm133 37h37v-83h50v-37h-50v-48h50v-37h-87zM260 856q-24 0-42-18t-18-42V236q0-24 18-42t42-18h560q24 0 42 18t18 42v560q0 24-18 42t-42 18zm0-60h560V236H260zM140 976q-24 0-42-18t-18-42V296h60v620h620v60zm120-740v560z"
  })));
};
export default SvgPictureAsPdf;